export enum AddressEnum {
  City = 'city',
  Full = 'full',
  Geocode = 'geocode',
  LineOne = 'lineOne',
  LineOneAndCity = 'lineOneAndCity',
  LineTwo = 'lineTwo',
  Zip = 'zip',
  ZipFull = 'fullZip'
}
